import { render } from "./IconClose.vue?vue&type=template&id=e1110f4e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1110f4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1110f4e', __exports__)) {
    api.reload('e1110f4e', __exports__)
  }
  
  module.hot.accept("./IconClose.vue?vue&type=template&id=e1110f4e", () => {
    api.rerender('e1110f4e', render)
  })

}


export default __exports__